import React from 'react';

import {Icon, IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {RuleActionTypesEnum} from '../ruleActionModel';

/*
 * Types.
 */

interface RuleActionIconProps {
  id: RuleActionTypesEnum;
}

/*
 * Component.
 */

export const RuleActionIcon = ({id}: RuleActionIconProps) => <Icon name={getIconName(id)} />;

/*
 * Helpers.
 */

function getIconName(id: RuleActionTypesEnum): IconName {
  switch (id) {
    case RuleActionTypesEnum.TAG:
      return 'tagFilled';

    case RuleActionTypesEnum.UNTAG:
      return 'untag';

    case RuleActionTypesEnum.NOTIFY_TEAMMATES:
    case RuleActionTypesEnum.NOTIFY_ASSIGNEE:
    case RuleActionTypesEnum.NOTIFY_ACCOUNT_FIELD:
      return 'bell';

    case RuleActionTypesEnum.ADD_COMMENT:
    case RuleActionTypesEnum.ADD_EXPRESSIONS_LOG_COMMENT:
      return 'chatFilled';

    case RuleActionTypesEnum.ASSIGN:
    case RuleActionTypesEnum.RANDOM_ASSIGN:
    case RuleActionTypesEnum.ASSIGN_CONTACT_FIELD:
    case RuleActionTypesEnum.ASSIGN_ACCOUNT_FIELD:
      return 'assignFilled';

    case RuleActionTypesEnum.UNASSIGN:
      return 'unassign';

    case RuleActionTypesEnum.MOVE:
      return 'moveActivityFilled';

    case RuleActionTypesEnum.REPLY:
      return 'reply';

    case RuleActionTypesEnum.ARCHIVE:
      return 'archiveFilled';

    case RuleActionTypesEnum.UNARCHIVE:
      return 'reopen';

    case RuleActionTypesEnum.SNOOZE:
      return 'snoozeFilled';

    case RuleActionTypesEnum.TRASH:
      return 'trashFilled';

    case RuleActionTypesEnum.ADD_CONTACT_TO_GROUP:
    case RuleActionTypesEnum.REMOVE_CONTACT_FROM_GROUP:
      return 'contactsFilled';

    case RuleActionTypesEnum.FORWARD:
      return 'arrowForward';

    case RuleActionTypesEnum.CREATE_TOPICS:
    case RuleActionTypesEnum.AUTOLINK:
      return 'formattingLink';

    default:
      return 'moveActivityFilled';
  }
}
